import { wagmiConfig as config, } from "@wagmiconfig";
import { getTokenDefinition, } from "@bracket/chainography";
import { mint as mintBrktETH, } from "@bracket/contractor-next/brktETH";
import { amountToBigInt, } from "../helpers";
import type { BuyProps, BuyResult, } from "./buy";



/**
 * Executes operation to mint BRKTETH tokens
 * @param {MintProps} props - The mint parameters
 * @param {TokenIdentifier} props.tokenIn - The input token identifier
 * @param {AmountString} props.amountIn - The amount to mint
 * @returns {Promise<BlockHash | null>} The transaction block hash if successful, null if failed
 * @throws {Error} If the mint operation fails
 */
export const mint = async ({
	tokenIn,
	amountIn,
}: BuyProps): Promise<BuyResult> => {

  const tokenInDefinition = getTokenDefinition(tokenIn);
	const amountInBigInt = amountToBigInt(amountIn, tokenInDefinition);
	const hash = await mintBrktETH({
		token: tokenInDefinition,
		amount: amountInBigInt,
		minAmount: amountInBigInt,
		config,
	})
	.catch(err => {
		console.warn(`@bracket/platform/client/store/slices/swap/resolvers/mint has failed - ${err instanceof Error ? err.message : "unknown error"}`);
		return null;
	});

	if(hash) {
		return {
			hash,
			error: undefined,
		};
	}

	return {
		hash: null,
		error: new Error("mint.resolvers.mint has failed"),
	};

};
